<template>
	<div class="card">
		<div class="card-body">
			<div class="flex flex-wrap items-center justify-between gap-3">
				<div class="card-title flex items-center gap-2">
					<span>{{ _tr('users.users') }}</span>
					<span class="loading loading-spinner loading-xs" v-if="isLoading"></span>
				</div>
				<div class="flex flex-row items-center gap-2">
					<label class="input input-sm">
						<Search :size="16" />
						<input
							type="search"
							:placeholder="_tr('users.filter')"
							aria-label="Filter users"
							v-model="search" />
					</label>
					<button class="btn btn-soft btn-primary btn-sm" @click="openAddModal">
						{{ _tr('users.addNewUser') }}
					</button>
				</div>
			</div>
		</div>
	</div>
	<UserDetails :selectedUser="selectedUser" />
</template>

<script setup lang="ts">
	import { Search } from 'lucide-vue-next'
	import { useI18n } from 'vue-i18n'
	import { _translations } from './_translations'
	import { useUserData } from './useUser'
	import { useVfm } from 'vue-final-modal'
	import UserDetails from './UserDetails.vue'

	const { t: _tr } = useI18n(_translations)
	const { search, isLoading, selectedUser } = useUserData()
	const vfm = useVfm()

	const openAddModal = () => {
		selectedUser.value = {
			accessProjects: [],
			email: '',
			password: '',
			role: 'user',
		}
		vfm.open('modal-edit-user')
	}
</script>
